module.exports = __webpack_public_path__ + "img/confessions.d00c13c9.png";